// extracted by mini-css-extract-plugin
module.exports = {"SubTopic":"SubTopic_SubTopic__PtPWT","Description":"SubTopic_Description__AABuH"};